var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpicS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 1.83333V1H7.65835V1.83333H3.5ZM10.1667 1.83333H11V1.00415H10.1667V1.83333ZM3.92084 6.82085H3.0875V5.99169H3.92084V6.82085ZM9.32916 8.48752H8.49583V7.65836H9.32916V8.48752ZM2.67918 9.32086H8.49583V8.49169H2.67918V9.32086ZM1.83333 10.975H9.32916V10.1459H1.83333V10.975ZM1.8375 8.48752H2.67084V7.65836H1.8375V8.48752ZM2.67084 3.49566H1.8375V2.66647H2.66667V1.83748H3.5V2.66667H2.67084V3.49566ZM8.49583 3.49566H9.32916V2.66647H8.49583V1.83748H7.6625V2.66667H8.49583V3.49566ZM10.1625 7.65799H9.32916V3.49966H10.1625V7.65799ZM1 7.65799H1.83333V3.49966H1V7.65799ZM6.84167 5.99566H6.00834V5.16233H5.17501V4.32899H6.00834V3.49983H6.84167V4.32899H7.67084V5.16233H6.84167V5.99566Z",
    fill: "#FF3FF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicS);
export default __webpack_public_path__ + "static/media/epic-s.b59fc66cfea5341aeabe935cb9fdc549.svg";
export { ForwardRef as ReactComponent };